module.exports = "/_next/static/files/c56df31b3320156ceb0ef11c3a98d215.png";